var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedCircle = function SvgCheckedCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.333.57a6 6 0 1 0 6 6 6.018 6.018 0 0 0-6-6Zm3.604 3.853-4.5 4.5a.499.499 0 0 1-.707 0l-2-2a.5.5 0 1 1 .707-.707l1.646 1.647L9.23 3.716a.5.5 0 1 1 .707.707Z",
    fill: "#fff"
  })));
};
export default SvgCheckedCircle;